var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockperson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 96,
    viewBox: "0 0 122 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8605_58580)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.3244 44C94.8758 44 98.275 44.4 101.471 45.16V40C101.471 35.6 96.9051 32 91.3244 32H86.251V24C86.251 12.96 74.8866 4 60.884 4C46.8815 4 35.5171 12.96 35.5171 24V32H30.4437C24.8629 32 20.2969 35.6 20.2969 40V80C20.2969 84.4 24.8629 88 30.4437 88H62.2031C58.1951 83.48 55.8106 77.96 55.8106 72C55.8106 56.52 71.6904 44 91.3244 44ZM45.1565 24C45.1565 17.16 52.2085 11.6 60.884 11.6C69.5595 11.6 76.6116 17.16 76.6116 24V32H45.1565V24Z",
    fill: "#0A3575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.3279 52C77.3253 52 65.9609 60.96 65.9609 72C65.9609 83.04 77.3253 92 91.3279 92C105.33 92 116.695 83.04 116.695 72C116.695 60.96 105.33 52 91.3279 52ZM91.3279 60C95.5388 60 98.938 62.68 98.938 66C98.938 69.32 95.5388 72 91.3279 72C87.117 72 83.7178 69.32 83.7178 66C83.7178 62.68 87.117 60 91.3279 60ZM91.3279 84C86.1023 84 81.4855 81.92 78.7459 78.72C82.4495 77.04 86.7111 76 91.3279 76C95.9447 76 100.206 77.04 103.91 78.72C101.17 81.92 96.5535 84 91.3279 84Z",
    fill: "#0A3575"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8605_58580"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 121.761,
    height: 96,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockperson);
export default __webpack_public_path__ + "static/media/lockperson.63c8294b470eb822caf25f1c01bec265.svg";
export { ForwardRef as ReactComponent };